import React from 'react';
import {Link} from 'react-router-dom';
import './Breadcrum.css';


const Breadcrums = (props) => {
    const {product} = props;

    const categoryName =
        product.category === "Pen" ? "Ручка" :
            product.category === "Keychain" ? "Брелкі" :
                product.category === "Candle_holders" ? "Підсвічник" :
                    product.category;


    return (
        <nav className='breadcrum'>
            <Link to={`/${product.category}`}>{categoryName}</Link> &gt; {product.name}
        </nav>
    )
}

export default Breadcrums;

// <a href={product.category}>{product.category}</a> - так було раніше
// також замінив > на &gt; — це HTML-код для символу "більше", щоб уникнути помилок або небажаного парсингу.